export default {
    company: {
        label: window.i18n.__('Société'),
        type: 'company',
    },
    person: {
        label: window.i18n.__('Particulier'),
        type: 'individual',
    },
    client: {
        label: window.i18n.__('Client'),
        type: 'client',
    },
    prospect: {
        label: window.i18n.__('Prospect'),
        type: 'prospect',
    },
    supplier: {
        label: window.i18n.__('Fournisseur'),
        type: 'supplier',
    },
    contact: {
        label: window.i18n.__('Contact'),
        type: 'contact',
    },
    archived: {
        label: window.i18n.__('Archivé'),
        type: 'archived',
    },
};
